import { useGLTF } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import { imagePreloader } from "@/utils/image-preloader";

import { useSocketContext } from "../../../context/socket-context-provider";

export const InfoBook = (props) => {
    const { nodes, materials } = useGLTF("/general/info-book.glb");
    const [open, setOpen] = useState(false);
    const { registerItem } = useSocketContext();
    const infoBookPaper = useRef();
    const infoBookCover = useRef();
    const infoBookText1 = useRef();
    const infoBookDeco = useRef();
    const { i18n } = useTranslation();
    const isEn = i18n.language === "en";

    useFrame((state, delta) => {
        if (open) {
            if (infoBookPaper?.current?.rotation.x < Math.PI) {
                infoBookCover.current.rotation.x += 2 * delta;
                infoBookPaper.current.rotation.x += 2 * delta;
                infoBookText1.current.rotation.x += 2 * delta;
                infoBookDeco.current.rotation.x += 2 * delta;
            }
        } else {
            if (infoBookPaper?.current?.rotation.x > 0) {
                infoBookCover.current.rotation.x -= 2 * delta;
                infoBookPaper.current.rotation.x -= 2 * delta;
                infoBookText1.current.rotation.x -= 2 * delta;
                infoBookDeco.current.rotation.x -= 2 * delta;
            }
        }
    });

    const book = {
        uuid: "695a8d5f-a606-4b80-aaf4-47f24042d524",
        type: "item",
        name: "InfoBook",
        image: "/general/info-book.webp",
        position: [0, 0, 0],
        rotation: [0, 0, 0],
        scale: 1,
        inspectScale: 7,
        inspectRotation: [0, -Math.PI / 2, -1.5],

        mesh: [
            {
                geometry: nodes.Cube003.geometry,
                material: materials.Purple,
                ref: infoBookCover,
                clickEvent: () => setOpen((prev) => !prev),
                hoverEvent: true,
            },
            {
                geometry: nodes.Cube003_1.geometry,
                material: materials.Paper,
                ref: infoBookPaper,
                clickEvent: () => setOpen((prev) => !prev),
                hoverEvent: true,
            },
            {
                geometry: nodes.Cube003_2.geometry,
                material: materials.Black,
                ref: infoBookDeco,
                clickEvent: () => setOpen((prev) => !prev),
                hoverEvent: true,
            },
            {
                geometry: nodes.Cube003_3.geometry,
                material: isEn ? materials.InfoText1En : materials.InfoText1,
                ref: infoBookText1,
                clickEvent: () => setOpen((prev) => !prev),
                hoverEvent: true,
            },
            {
                geometry: nodes.Cube002.geometry,
                material: materials.Purple,
                clickEvent: () => setOpen((prev) => !prev),
                hoverEvent: true,
            },
            {
                geometry: nodes.Cube002_1.geometry,
                material: materials.Paper,
                clickEvent: () => setOpen((prev) => !prev),
                hoverEvent: true,
            },
            {
                geometry: nodes.Cube002_2.geometry,
                material: isEn ? materials.InfoText2En : materials.InfoText2,
                clickEvent: () => setOpen((prev) => !prev),
                hoverEvent: true,
            },
        ],
    };

    useEffect(() => {
        imagePreloader(["/general/info-book.webp"]);
        registerItem(book, "pickedup");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
